module.exports = __webpack_public_path__ + "static/media/jesse.7157ffd4.jpg";